export function isEven(value: number) {
  return Boolean(!(value & 1));
}

export function isOdd(value: number) {
  return Boolean(value & 1);
}
